"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _EmployeeLookupContext = require("../employee-lookup/EmployeeLookupContext");

var _context = require("../context");

var _layout = require("../layout");

var _propTypes = require("../prop-types");

var _text = require("../text");

var _utils = require("../utils");

var _avatarConstants = require("./avatarConstants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledPronouns = (0, _context.styledWithTheme)(_text.Text)(function (_ref) {
  var theme = _ref.theme;
  return {
    fontWeight: theme.selectors.fontWeight('regular')
  };
});
var StyledAvatarNameLine = (0, _context.styledWithTheme)(_layout.Row)(function (_ref2) {
  var isInEmployeeLookup = _ref2.isInEmployeeLookup;
  return _objectSpread({
    display: 'flex',
    alignItems: 'center',
    flexWrap: !isInEmployeeLookup ? 'wrap' : undefined,
    gridGap: '0.3rem'
  }, isInEmployeeLookup && {
    flex: '0 1 auto',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  });
});
var StyledAvatarFullname = (0, _context.styledWithTheme)(_text.Text, {
  shouldForwardProp: (0, _utils.filterProps)(['isInEmployeeLookup'])
})(function (_ref3) {
  var isInEmployeeLookup = _ref3.isInEmployeeLookup;
  return _objectSpread({}, isInEmployeeLookup && {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1
  });
});
StyledAvatarNameLine.displayName = 'StyledAvatarNameLine';

var AvatarName = function AvatarName(_ref4) {
  var id = _ref4.id,
      fullName = _ref4.fullName,
      showFullName = _ref4.showFullName,
      pronouns = _ref4.pronouns,
      fontSize = _ref4.fontSize,
      lineHeight = _ref4.lineHeight,
      fontWeight = _ref4.fontWeight,
      colorScheme = _ref4.colorScheme,
      alternateName = _ref4.alternateName,
      hasRenderNameWrapper = _ref4.hasRenderNameWrapper;
  var isInEmployeeLookup = (0, _react.useContext)(_EmployeeLookupContext.EmployeeLookupContext);
  var colorSchemeValues = colorScheme === _interfaces.AvatarColorScheme.Inverted ? _avatarConstants.INVERTED_COLOR_SCHEME : _avatarConstants.DEFAULT_COLOR_SCHEME;
  var textProps = {
    fontSize: hasRenderNameWrapper ? 'inherit' : fontSize,
    lineHeight: hasRenderNameWrapper ? 'inherit' : lineHeight,
    fontWeight: hasRenderNameWrapper ? 'inherit' : fontWeight
  };
  return (0, _core.jsx)(StyledAvatarNameLine, {
    "data-test-component": _avatarConstants.AVATAR_NAME_LINE_DATA_TEST_COMPONENT,
    isInEmployeeLookup: isInEmployeeLookup
  }, showFullName && fullName && (0, _core.jsx)(StyledAvatarFullname, (0, _extends2.default)({}, textProps, {
    id: "".concat(_avatarConstants.COMPONENT_FULL_NAME_ID, "-").concat(id),
    color: hasRenderNameWrapper ? 'inherit' : colorSchemeValues.textColor,
    "data-test-component": _avatarConstants.COMPONENT_FULL_NAME,
    isInEmployeeLookup: isInEmployeeLookup
  }), fullName), alternateName && (0, _core.jsx)(_text.Text, (0, _extends2.default)({}, textProps, {
    id: "".concat(_avatarConstants.COMPONENT_ALTERNATE_NAME_ID, "-").concat(id),
    color: colorSchemeValues.textColor,
    "data-test-component": _avatarConstants.COMPONENT_ALTERNATE_NAME
  }), "(", alternateName, ")"), pronouns && (0, _core.jsx)(StyledPronouns, (0, _extends2.default)({}, textProps, {
    id: "".concat(_avatarConstants.COMPONENT_PRONOUNS_ID, "-").concat(id),
    color: colorSchemeValues.pronounColor,
    "data-test-component": _avatarConstants.COMPONENT_PRONOUNS
  }), "(", pronouns, ")"));
};

AvatarName.displayName = 'AvatarName'; // This component is not exported, hence doesn't need to be described. However, it uses cssValue which is described and currently incompatible with react PropTypes.

var AvatarNameWithDocs = (0, _stencilReactDesc.describe)(AvatarName).description('Used to graphically represent Amazonians.');
AvatarNameWithDocs.propTypes = _objectSpread(_objectSpread({}, _avatarConstants.sharedPropTypes), {}, {
  fullName: _stencilReactDesc.PropTypes.string.description('Full name of the displayed employee.'),
  showFullName: _stencilReactDesc.PropTypes.bool.description("Indicates whether the employee's full name should be displayed."),
  pronouns: _stencilReactDesc.PropTypes.string.description('Sets pronouns to be displayed next to the full name.'),
  alternateName: _stencilReactDesc.PropTypes.string.description('Sets alternate name to be displayed next to the full name.'),
  fontSize: (0, _propTypes.cssValue)().description("Sets the CSS 'font-size' property for the full name and username. Supports named font sizes from the Theme.").isRequired,
  fontWeight: (0, _propTypes.cssValue)().description("Sets the CSS 'font-weight' property for the full name. Supports named font weights from the Theme.").isRequired
});
AvatarNameWithDocs.privateProps = ['fontSize', 'fontWeight', 'usernameComponent'];
var _default = AvatarNameWithDocs;
exports.default = _default;